import React from "react";
import { useTranslate } from 'react-redux-multilingual';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import swal from "sweetalert2";

// Style import
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan } from '@fortawesome/free-solid-svg-icons';

const  CancelCollectActionButton = (props) => {
    const t = useTranslate();

    return (
            <OverlayTrigger
                placement="bottom"
                overlay={
                    <Tooltip>
                        {t(props.nameType)}
                    </Tooltip>
                }
            >
                <span 
                    className={`${props.spanClass || "text-danger"}`}
                    style={{cursor:'pointer',...(props.spanStyle || {})}} 
                    onClick={() => {
                        if (props.line && props.line!=null) {
                            if (Object.keys(props.line.child_facture_article_list).length!=0 && props.line.child_facture_article_list.some(value => value.facture.type=='deliveryNote')) { // Si converti
                                swal.fire({
                                    title: t('lineConverted'),
                                    icon: "warning",
                                })
                            }
                            else {
                                swal.fire({
                                    title: t(props.actionType)+" "+props.toDelete+"?",
                                    icon: "warning",
                                    type: "question",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText: t('btnYes'),
                                    cancelButtonText: t('btnNo'),
                                })
                                .then((result) => {
                                    if (result.value) {
                                        props.customClickEvent(props.line)
                                    }
                                });
                            }
                        }
                    }}
                >
                    <FontAwesomeIcon icon={faBan} />
                </span>
            </OverlayTrigger>  
    )
}

export default CancelCollectActionButton;